import type { Collection, CollectionId } from "../domain/types";

export function getCollectionId(collection: Collection): CollectionId {
  switch (collection.type) {
    case "album":
      return collection.album.id;
    case "artist":
      return collection.artist.id;
    case "playlist":
      return collection.playlist.id;
    case "foryou":
      return collection.foryou.id;
  }
}
